<template>
  <el-dialog
    class="dialog-form"
    :title="title"
    :visible.sync="showDialog"
    width="540px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="90px" class="form-wrap">
      <el-form-item prop="maintainDate" :label="tag+'日期'">
        <el-date-picker
          type="date"
          :placeholder="'请选择'+tag+'日期'"
          v-model="formData.maintainDate"
          style="width:100%"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item v-if="typeShow" prop="maintainTypeIds" label="养护类型">
        <el-select v-model="formData.maintainTypeIds" filterable placeholder="请选择养护类型" style="width:100%" multiple :multiple-limit = '4'>
          <el-option v-for = "(item, index) in maintainList" :key= "index" :label="item.dicValue" :value="item.dicCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="tag + '内容'" prop="maintainContent">
        <el-input
          type="textarea"
          maxlength="300"
          :rows="8"
          show-word-limit
          v-model="formData.maintainContent"
          :placeholder="'请输入' + tag + '内容'"
        ></el-input>
      </el-form-item>
      <div v-if="isSeedling">
        <el-form-item label="养护状态">
          <el-select v-model="formData.maintainStatus" filterable placeholder="请选择养护状态" style="width:100%" clearable>
            <el-option v-for = "(item, index) in seedlingStatusList" :key= "index" :label="item.dicValue" :value="item.dicCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="苗木定级">
          <el-select v-model="formData.qualityLevel" filterable placeholder="请选择苗木定级" style="width:100%" clearable>
            <el-option v-for = "(item, index) in seedlingLevelList" :key= "index" :label="item.dicValue" :value="item.dicCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价值评估" prop="valueAssessment">
            <el-input v-model="formData.valueAssessment"  placeholder="请输入价值评估（元）" maxlength="12" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="胸径：" prop="chestDiameter">
            <el-input v-model="formData.chestDiameter"  placeholder="请输入胸径（cm）" maxlength="12" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="冠幅：" prop="crownWidth">
            <el-input v-model="formData.crownWidth"  placeholder="请输入冠幅（cm）" maxlength="12" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="树高：" prop="treeHeight">
            <el-input v-model="formData.treeHeight"  placeholder="请输入树高（cm）" maxlength="12" show-word-limit clearable></el-input>
        </el-form-item>
    </div>

      <el-form-item prop="fileList">
        <template slot="label">
          <span>{{tag}}图片<br>(最多六张)</span>
        </template>
        <div class="imgList">
          <template v-if="formData.fileList && formData.fileList.length > 0">
            <div class="imgBlock" v-for="(item, index) in formData.fileList" :key="index">
              <el-image
                :src="item.filePrefix + item.fileUrl"
                :preview-src-list="[item.filePrefix + item.fileUrl]"
                fit="fill">
              </el-image>
              <span></span>
              <i class="el-icon-close" @click="imgRemove(index)"></i>
            </div>
          </template>
          <UploadFile v-if="!formData.fileList || formData.fileList.length < 6" @onSuccess= "onSuccess" :slotShow='true'>
            <template>
              <i class="el-icon-plus"></i>
              <p>上传图片</p>
            </template>
          </UploadFile>
        </div>
      </el-form-item>
      <p v-if="tipsShow" class="tips">备注：养护状态、生长指标、苗木定级、价值评估暂不支持批量维护</p>
      <div class="form-item-btn">
        <el-button class="btn" type="primary" :disabled='saveDisabled' @click="save">保存</el-button>
        <el-button class="btn cancel-btn" @click="cancel">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
  import UploadFile from '@/components/uploadFile/Index.vue'
  import { maximun, twoDecimal } from '@/utils/validate'
  export default {
    name: 'MaintenanceDialog',
    components: { UploadFile },
    props: {
      title: {
        type: String,
        default: '添加养护档案'
      },
      showDialog: {
        type: Boolean,
        default: false
      },
      tag: {
        type: String,
        default: '养护'
      },
      typeShow: {
        type: Boolean,
        default: false
      },
      requiredContent: {
        type: Boolean,
        default: true
      },
      // 是否显示养护状态、价值评估、胸襟、冠幅、树高（新增普通苗木单个档案以及查看普通苗木记录显示）
      isSeedling: {
        type: Boolean,
        default: false
      },
      // 批量新增文字提示是否显示
      tipsShow: {
        type: Boolean,
        default: false
      },
      formData: {
        type: Object,
        default: () => {
          return {
            maintainDate: '',
            maintainContent: '',
            fileList: [],
            maintainTypeIds: [],
            maintainStatus: '',
            chestDiameter: '',
            crownWidth: '',
            treeHeight: '',
            qualityLevel: '',
            valueAssessment: ''
          }
        }
      }
    },
    data () {
      return {
        saveDisabled: false,
        rules: {
          maintainDate: [
            {
              required: true,
              message: `请选择${this.tag}日期`,
              trigger: 'blur'
            }
          ],
          maintainContent: [
            { required: this.requiredContent, message: `请填写${this.tag}内容`, trigger: 'blur' }
          ],
          maintainTypeIds: [
            { required: true, message: '请选择养护类型', trigger: 'blur' }
          ],
          valueAssessment: [
            { validator: twoDecimal },
            { validator: this.maximum }
          ],
          chestDiameter: [
            { validator: twoDecimal },
            { validator: this.maximum }
          ],
          crownWidth: [
            { validator: twoDecimal },
            { validator: this.maximum }
          ],
          treeHeight: [
            { validator: twoDecimal },
            { validator: this.maximum }
          ]
        },
        maintainList: [],
        seedlingStatusList: [],
        seedlingLevelList: []
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
      this.typeShow && this.getMaintainTypeList()
      if (this.isSeedling) {
        this.getMaintainStatusList()
        this.getQualityLevelList()
      }
    },
    methods: {
      // 查询养护类型
      getMaintainTypeList () {
        this.$axios.get(this.$apis.common.selectDicByList, {
          dicType: 'recordMaintainType'
        }).then((res) => {
          this.maintainList = res.recordMaintainType || []
        })
      },
      getMaintainStatusList () {
        this.$axios.get(this.$apis.common.selectDicByList, {
          dicType: 'maintainStatus'
        }).then((res) => {
          this.seedlingStatusList = res.maintainStatus || []
        })
      },
      getQualityLevelList () {
        this.$axios.get(this.$apis.common.selectDicByList, {
          dicType: 'qualityLevel'
        }).then((res) => {
          this.seedlingLevelList = res.qualityLevel || []
        })
      },
      // 文件上传成功返回
      onSuccess (file) {
        this.formData.fileList.push(file)
      },
      imgRemove (index) {
        this.formData.fileList.splice(index, 1)
      },
      handleClose () {
        this.$emit('close')
      },
      save () {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$emit('save', this.formData)
          }
        })
      },
      cancel () {
        this.$emit('close')
      },
      // 按钮状态切换
      saveDisabledShow () {
        this.saveDisabled = false
      },
      destroyed () {
        this.saveDisabled = false
      }
    }
  }
</script>

<style lang='scss' scoped>
@import "@/assets/scss/color";
.dialog-form {
.tips{
  padding-left: 30px;
}
::v-deep .el-dialog__body {
  padding: 0;
  .el-form-item--small.el-form-item{
    margin-bottom: 30px;
  }
}
::v-deep .el-dialog__header {
  border-bottom: 1px solid #dddddd;
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px  0  20px;
  .el-dialog__title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
}
}
.form-wrap {
padding: 30px 58px 40px 20px;
.form-item-btn {
  text-align: center;
  margin-top: 30px;
  margin-left: 30px;
  .btn {
    width: 60px;
    &.cancel-btn {
      margin-left: 10px;
    }
  }
}

.imgList{
  display: flex;
  flex-wrap: wrap;
  .imgBlock {
    position: relative;
    height: 104px;
    width: 104px;
    margin:0 10px 10px 0;
    .el-image,img{
      width:100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }
    i:hover {
      color: #ffffff98;
    }
  }
  ::v-deep .el-upload--picture-card{
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding:25px 10px;
  }
}
}
</style>
